import { render, staticRenderFns } from "./ColoredAvatar.vue?vue&type=template&id=4465d8af&scoped=true&"
import script from "./ColoredAvatar.vue?vue&type=script&lang=js&"
export * from "./ColoredAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ColoredAvatar.vue?vue&type=style&index=0&id=4465d8af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465d8af",
  null
  
)

export default component.exports